import {
    calendarDateSchema,
    zonedDateTimeToUtc,
    type IanaTimeZone,
    type UtcInstant,
} from '@baby-tracker/validation';

/** Interprets a `datetime-local` value as wall time in the family time zone. */
export function familyDateTimeToUtc(value: string, timeZone: IanaTimeZone): UtcInstant | undefined {
    const match = /^(\d{4}-\d{2}-\d{2})T([01]\d|2[0-3]):([0-5]\d)$/.exec(value);
    if (match === null) {
        return undefined;
    }
    const date = calendarDateSchema.safeParse(match[1]);
    const hour = match[2];
    const minute = match[3];
    if (!date.success || hour === undefined || minute === undefined) {
        return undefined;
    }
    return zonedDateTimeToUtc(date.data, `${hour}:${minute}`, timeZone);
}
